import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { catchError, delay, map, mergeMap, tap } from 'rxjs/operators';
import { concat, of } from 'rxjs';
import { ToastrConfigs } from "../../@core/data/toastr-config";
import { NbToastrService } from "@nebular/theme";
import { SagaService } from "../../@core/data/saga/saga.service";
import { GestiuniError, GestiuniLoaded, GestiuniLoading, GestiuniRequested } from './gestiuni.actions';

@Injectable()
export class GestiuniEffects {
  constructor(
    private actions$: Actions,
    private toastrService : NbToastrService,
    private sagaService: SagaService
  ) {}

  requestGestiuni$ = createEffect(() =>
    this.actions$.pipe(
      ofType(GestiuniRequested),
      mergeMap(() =>
        concat(
          of(GestiuniLoading()),
          this.sagaService.getGestiuniSaga().pipe(
            map((response: any) => GestiuniLoaded({ gestiuni: response?.data })),
            catchError((error: any) => of(GestiuniError()))
          )
        )
      )
    )
  );

  onError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(GestiuniError),
        tap(() => {
          this.toastrService.show(`Lista gestiunilor nu a putut fi încărcată!`, `Eroare`, ToastrConfigs.danger);
        })
      ),
    { dispatch: false }
  );
}
